import React, { useState, useEffect } from 'react';
import './LoginStyles.css';
import goldMedal from '../Images/GoldMedal.png';
import silverMedal from '../Images/SilverMedal.png';
import bronzeMedal from '../Images/BronzeMedal.png';


function Scoreboard() {
  const [scores, setScores] = useState([]);
  const [selectedSurvey, setSelectedSurvey] = useState('CanadaSurvey');
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  useEffect(() => {
    const fetchScores = async () => {
      const response = await fetch(`${apiUrl}/top-scores/${selectedSurvey}`);
      if (response.ok) {
        const data = await response.json();
        setScores(data);
      } else {
        console.error('Failed to fetch scores');
      }
    };

    fetchScores();
  }, [apiUrl, selectedSurvey]);

  const handleSelectChange = (e) => {
    setSelectedSurvey(e.target.value);
  };

  return (
    <div className='container mt-5'>
      <h1 className="mb-4">Scoreboard</h1>
      <select className="form-select mb-4" value={selectedSurvey} onChange={handleSelectChange}>
        <option value="CanadaSurvey">Canada</option>
        <option value="ChinaSurvey">China</option>
        <option value="PhilippinesSurvey">Philippines</option>
        <option value="VenezuelaSurvey">Venezuela</option>
      </select>
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Position</th>
            <th>Name</th>
            <th>Score</th>
            <th>Medal</th>
          </tr>
        </thead>
        <tbody>
          {scores.map((score, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{`${score.firstName} ${score.lastName}`}</td>
              <td>{score.score}</td>
              <td>
                {index === 0 ? <img src={goldMedal} alt="Gold Medal" width="30" /> :
                  index === 1 ? <img src={silverMedal} alt="Silver Medal" width="30" /> :
                    index === 2 ? <img src={bronzeMedal} alt="Bronze Medal" width="30" /> : ""}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Scoreboard;
